import { ChangeDetectionStrategy, Component, ElementRef } from "@angular/core";
import _ from "lodash";
import { SmFormFieldBase } from "./sm-form-field-base.component";
import { SmFormService } from "../sm-form-service";

@Component({
    standalone: false,
    selector: 'sm-form-field-decimal',
    templateUrl: './sm-form-field-decimal.component.html',
    outputs: ['onValueChanged', 'onFocusChanged'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmFormFieldDecimalComponent extends SmFormFieldBase {

    constructor(protected service: SmFormService, protected element: ElementRef) {
        super(service, element);
    }

    public valueChange(e: any) {
        this.model.Value =  e;
        super.valueChange(e, 'input');
    }
}